<template>
  <CustomDeleteDialog
    dialogTitle="حذف گروه‌بندی"
    dialogId="delete-lesson-category-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="deleteLessonCategory"
  >
    <BCol cols="12">
      <p>آیا از حذف این گروه‌بندی اطمینان دارید؟</p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  props: {
    defaultLessonCategoryId: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async deleteLessonCategory() {
      if (this.defaultLessonCategoryId) {
        try {
          this.isOkButtonDisabled = true;
          const _this = this;
          let deleteLessonCategory = new DeleteLessonCategory(_this);
          deleteLessonCategory.setRequestParam({
            id: _this.defaultLessonCategoryId,
          });
          await deleteLessonCategory.fetch((res) => {
            if (res.isSuccess) {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "حذف شد!",
                  icon: "CheckIcon",
                  variant: "success",
                  text: "گروه‌بندی درس با موفقیت حذف شد.",
                },
              });
              _this.$bvModal.hide("delete-lesson-category-dialog");
              _this.$emit("refetch");
            } else {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "حذف نشد!",
                  icon: "XIcon",
                  variant: "danger",
                  text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
                },
              });
              this.$bvModal.hide("delete-lesson-category-dialog");
            }
          });
        } catch (error) {
          console.error(error);
        } finally {
          this.isOkButtonDisabled = false;
        }
      } else {
        _this.$toast({
          component: ToastificationContent,
          props: {
            title: "حذف نشد!",
            icon: "XIcon",
            variant: "danger",
            text: "لطفا گروه‌بندی را مجدد انتخاب کنید!",
          },
        });
      }
    },
  },
  components: {
    CustomDeleteDialog,
    IndependentLessonPicker,
    BCol,
    TextInput,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import IndependentLessonPicker from "@/views/components/Lessons/IndependentLessonPicker.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { DeleteLessonCategory } from "@/libs/Api/LessonCategory";
</script>
